import { useState } from "react";
import { startReport } from "./teacherReportsMetricsApi";

const HTTP_CONFLICT = 409;

const failureText = (error) =>
  error?.status === HTTP_CONFLICT && error.detail ? error.detail : "Could not start the report. Try again.";

export const useReportStarts = (onStarted) => {
  const [startingIds, setStartingIds] = useState([]);
  const [startFailures, setStartFailures] = useState({});

  const settle = (sessionId, failure) => {
    setStartingIds((ids) => ids.filter((id) => id !== sessionId));
    setStartFailures((failures) => ({ ...failures, [sessionId]: failure }));
  };

  const start = (sessionId) => {
    setStartingIds((ids) => [...ids, sessionId]);
    startReport(sessionId).then(
      () => {
        settle(sessionId, null);
        onStarted(sessionId);
      },
      (error) => settle(sessionId, failureText(error))
    );
  };

  const forgetFailures = () => setStartFailures({});

  return { startingIds, startFailures, start, forgetFailures };
};
